import React from 'react';

const ShareholderRelationshipNews = React.lazy(() =>
  import('pages/ShareholderRelationshipNews/ShareholderRelationshipNews'),
);
const ShareholderRelationshipNewsAdd = React.lazy(() =>
  import('pages/ShareholderRelationshipNews/ShareholderRelationshipNewsAdd'),
);
const ShareholderRelationshipNewsEdit = React.lazy(() =>
  import('pages/ShareholderRelationshipNews/ShareholderRelationshipNewsEdit'),
);
const ShareholderRelationshipNewsDetail = React.lazy(() =>
  import('pages/ShareholderRelationshipNews/ShareholderRelationshipNewsDetail'),
);

const shareholderRelationshipNewsRoutes = [
  {
    path: '/shareholder-relationship-news',
    exact: true,
    name: 'Danh sách tin tức',
    function: 'SHAREHOLDER-RELATIONSHIP_CATEGORY_VIEW',
    component: ShareholderRelationshipNews,
  },
  {
    path: '/shareholder-relationship-news/add',
    exact: true,
    name: 'Thêm mới tin tức',
    function: 'SHAREHOLDER-RELATIONSHIP_CATEGORY_ADD',
    component: ShareholderRelationshipNewsAdd,
  },
  {
    path: '/shareholder-relationship-news/detail/:id',
    exact: true,
    name: 'Chi tiết tin tức',
    function: 'SHAREHOLDER-RELATIONSHIP_CATEGORY_VIEW',
    component: ShareholderRelationshipNewsDetail,
  },
  {
    path: '/shareholder-relationship-news/edit/:id',
    exact: true,
    name: 'Chỉnh sửa tin tức',
    function: 'SHAREHOLDER-RELATIONSHIP_CATEGORY_EDIT',
    component: ShareholderRelationshipNewsEdit,
  },
];

export default shareholderRelationshipNewsRoutes;
